import { IBaseContact } from '../contacts/IBaseContact';
import { IPresentationContactData } from '../contacts/IPresentationContactData';

export interface ILenderUserResponse extends IBaseContact<string> {
  active: boolean;
  invitationSentAt?: string;
  activatedBy?: string;
  activatedAt?: string;
  deactivatedBy?: string;
  deactivatedAt?: string;
  email: string;
  phoneNumber: string;
  createdAt: string;
}

export type ILenderUserData = ILenderUserResponse;

export const convertFromLenderUserResponseToLenderUserData = (data: ILenderUserResponse): ILenderUserData => data;
export const convertFromLenderUserDataToLenderUserResponse = (data: ILenderUserData): ILenderUserResponse => data;

export const convertFromLenderUserResponseArrayToLenderUserDataArray = (
  data: ILenderUserResponse[]
): ILenderUserData[] => data;

export type IPresentationLenderUserData = IPresentationContactData<ILenderUserData, string>;
